import PaperclipIconPath from "@ingka/ssr-icon/paths/paperclip";

export default PaperclipIconPath;
